import { render, staticRenderFns } from "./AppSettingsParentCommsLocal.vue?vue&type=template&id=0d4311c7&"
import script from "./AppSettingsParentCommsLocal.vue?vue&type=script&lang=js&"
export * from "./AppSettingsParentCommsLocal.vue?vue&type=script&lang=js&"
import style0 from "./AppSettingsParentCommsLocal.vue?vue&type=style&index=0&id=0d4311c7&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports